export const deleteAccessToken = () => {
  localStorage.removeItem("access_token");
};
